export enum DataAssetSourceType {
    FILE = "FILE",
    CONNECTOR = "CONNECTOR",
}

export enum DataAssetDataType {
    BALANCE_SHEET = "BALANCE_SHEET",
    CHART_OF_ACCOUNTS = "CHART_OF_ACCOUNTS",
    INCOME_STATEMENT = "INCOME_STATEMENT",
    PROFIT_AND_LOSS = "PROFIT_AND_LOSS",
}

export interface DataAsset {
    id: string;
    companyId: string;
    sourceType: DataAssetSourceType;
    dataType: DataAssetDataType;
    updatedAt: string;
}
